/*
 * Project: BookingEngine
 * Module: components/booking/rooms/Ribbon.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';

// Basic Template of ribbon. ---
const BasicRibbonStruct = (props) => (
  <div className={`ribbon-wrapper ${props.type || ''}`}>
    <div className='ribbon-front' style={{
      backgroundColor: props.background_color ? props.background_color : 'initial',
      color: props.color ? props.color : 'initial',
      fontWeight: 'bold',
    }}>
      {props.children}
    </div>
    <div className='ribbon-edge-bottom' />
  </div>
);

// Basic Props of ribbon. ---
const BasicRibbonProps = {
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
};

// Ribbon Types. ---

// - Normal
export const Ribbon = (props) => (
  <BasicRibbonStruct {...props}>
    {props.label}
  </BasicRibbonStruct>
);

Ribbon.propTypes = {
  ...BasicRibbonProps,
};

// - Offer
export const RibbonOffer = (props) => {
  if (props.discount_to_show === 'NEW_MEMBER_DISCOUNT_PERCENTAGE') {
    let background_color = '#1AB9B7';
    let color = '#FFFFFF';
    if (props.membershipName.toLowerCase().includes('blue')) {
      background_color = '#1AB9B7';
      color = '#FFFFFF';
    }
    if (props.membershipName.toLowerCase().includes('silver')) {
      background_color = '#c0c0c0 ';
      color = '#000000';
    }
    if (props.membershipName.toLowerCase().includes('platinum')) {
      background_color = '#e5e4e2  ';
      color = '#000000';
    }
    if (props.membershipName.toLowerCase().includes('black')) {
      background_color = '#000000  ';
      color = '#e5e4e2';
    }
    if (props.membershipName.toLowerCase().includes('gold')) {
      background_color = '#F4C90B';
      color = '#000000';
    }
    return (
      <BasicRibbonStruct type="offer" background_color={background_color} color={color}>
        <span className="ribbon-offer__label">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{(props.agentCode !== '' && props.agentSell === 'false')
          ? 'Sandos Advisors' : props.loyalty_name.substr(-3, 3)}
          {props.new_member_discount_percentage_activated && props.new_member
            && <span><br/>-{props.new_member_discount_percentage}% {props.label}</span>
          }
        </span>
      </BasicRibbonStruct>
    );
  }
  const background_color = '#1AB9B7';
  const color = '#FFFFFF';
  return (
    <BasicRibbonStruct type="offer" background_color={background_color} color={color}>
      <span className={`ribbon-offer__discount ribbon-offer__discount--${props.discountPosition}`}>
        -{props.discount}%
      </span>
      <span className="ribbon-offer__label">&nbsp;{props.label}</span>
    </BasicRibbonStruct>
  );
};

RibbonOffer.propTypes = {
  discount: PropTypes.number,
  discountPosition: PropTypes.oneOf(['start', 'end']),
};

RibbonOffer.defaultProps = {
  discountPosition: 'start',
};

// - Double Room
export const RibbonDoubleRoom = (props) => (
  <BasicRibbonStruct type="double-room">
    {props.label}
  </BasicRibbonStruct>
);

RibbonDoubleRoom.propTypes = {
  ...BasicRibbonProps,
};
